module.exports = __webpack_public_path__ + "img/replace.7a9639d0.svg";